import { Cell, Column, Header } from '@tanstack/react-table';

function getColumn<T>(value?: Header<T, unknown> | Cell<T, unknown>, column?: Column<T, unknown>) {
  return column ?? value?.column;
}

export { getColumn };
